module.exports = __webpack_public_path__ + "static/media/logo.34d79de9.png";